import { AndroidNativeHardwareAdapter, hasAndroidNativeHardwareBridge } from "./android-native-adapter";
import { BrowserFallbackHardwareAdapter } from "./browser-adapter";
import type { HardwareRuntimeAdapter } from "./contracts";

export function createHardwareRuntime(): HardwareRuntimeAdapter {
  // Capability resolution belongs here. Business/UI code never branches on
  // Android, SUNMI, printer model, branch, or provider.
  if (hasAndroidNativeHardwareBridge()) {
    return new AndroidNativeHardwareAdapter();
  }
  return new BrowserFallbackHardwareAdapter();
}
